/**
 * @file 班级排行榜
 * @author liudaoyu
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

/**
 * 排行项信息
 */
export interface IRankingItemInfo {
    index?: number;
    rank_change?: number; // 0标识名次没变化；大于0表示上升；小于0表示下降
    total_complete_num?: number;
    user_info: IUserBaseInfo;
}

export interface IRankingsInput {
    class_id: number; // int，班级编号
    type: number; // int，榜单类型 1：完成榜；2：今日完成榜；3：昨日完成榜；4：最近7日完成榜；5：最近30日完成榜
    page: number; // int，页码
    size: number; // int，每页数量
}

export const getRankingsList = (data: IRankingsInput): Promise<IListResponse<IRankingItemInfo>> => {
    return fetchData(Api.CLASS_RANKINGS_LIST, data).then((res: IListResponse<IRankingItemInfo>) => {
        return res.data as IList<IRankingItemInfo>;
    });
};
